var CONFUSEDWEBSITE = CONFUSEDWEBSITE || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

(function ($) {

    CONFUSEDWEBSITE.setupOverlaps = function () {

        var $overlaps = $('.' + CSSCONSTANTS.overlapBandAboveClass),
            $overlapsNonMobile = $('.' + CSSCONSTANTS.overlapBandAboveNonMobileClass);

        $.each($overlaps, function () {
            CONFUSEDWEBSITE.createOverlap($(this));
        });

        enquire.register(CSSCONSTANTS.nonMobileHeaderMinWidthMQ, {

            match: function () {
                /* create overlap for non-mobile only overlaps */
                $.each($overlapsNonMobile, function () {
                    CONFUSEDWEBSITE.createOverlap($(this));
                });
            },
            unmatch: function () {
                $.each($overlapsNonMobile, function () {
                    CONFUSEDWEBSITE.removeOverlap($(this));
                });
            }
        }, true);


    };

    CONFUSEDWEBSITE.createOverlap = function ($itemToOverlap) {
        var $this = $itemToOverlap,
            $parentBand = $this.closest('.' + CSSCONSTANTS.bandClass),
            parentBandPaddingTop = $parentBand.css('padding-top'),
            $previousBand = $parentBand.prev('.' + CSSCONSTANTS.bandClass),
            previousBandPaddingBottom,
            $elementToAddBottomPaddingTo,
            thisHeight = $this.outerHeight();

        if ($previousBand.hasClass('hero-with-filtered-image')) {
            $elementToAddBottomPaddingTo = $previousBand.find('.hero-with-filtered-image__inner');
        }
        else {
            $elementToAddBottomPaddingTo = $previousBand;
        }
        $elementToAddBottomPaddingTo.css('padding-bottom', ''); /* remove any inline style added by previous running of function */
        previousBandPaddingBottom = $elementToAddBottomPaddingTo.css('padding-bottom'); /* get the padding value specified in the stylesheet */

        $this.css('margin-top', -((thisHeight / 2) + parseFloat(parentBandPaddingTop)));
        $this.css('margin-bottom', CSSCONSTANTS.gridUnit * 2 + 'px');
        $elementToAddBottomPaddingTo.css('padding-bottom', ((thisHeight / 2) + parseFloat(previousBandPaddingBottom)));
    };

    CONFUSEDWEBSITE.removeOverlap = function ($itemToRemoveOverlapFrom) {
        var $this = $itemToRemoveOverlapFrom,
            $parentBand = $this.closest('.' + CSSCONSTANTS.bandClass),
            $previousBand = $parentBand.prev('.' + CSSCONSTANTS.bandClass),
            $elementToRemoveBottomPaddingFrom;

        if ($previousBand.hasClass('hero-with-filtered-image')) {
            $elementToRemoveBottomPaddingFrom = $previousBand.find('.hero-with-filtered-image__inner');
        }
        else {
            $elementToRemoveBottomPaddingFrom = $previousBand;
        }

        $elementToRemoveBottomPaddingFrom.css('padding-bottom', ''); /* remove inline style added by running of createOverlap */
        $this.css('margin-top', ''); /* remove inline style added by running of createOverlap */

    };

})(window.jQuery);
